import type { FollowingState } from "../../../components/MapLibre/LineFollower";
import { NavigationMode } from "../../../types/Navigation";
import { defineEphemeralSlice } from "../runtime/defineEphemeralSlice";

/** Session navigation state (mode, camera follow, GPS line matching). */
export interface NavigationSession {
    "navigationMode":        NavigationMode;
    "isFollowingNavigation": boolean;

    /**
     * When true, the map camera continuously centers on the selected vehicle position.
     * Cleared on user map gesture, vehicle deselection, GPS navigation follow, or FAB GPS.
     */
    "isFollowingVehicle": boolean;
    "routeLineFollowing": FollowingState | null;
}

/** Default navigation session state. */
export const NAVIGATION_SESSION_DEFAULT: NavigationSession = {
    "navigationMode":        NavigationMode.EXPLORATION,
    "isFollowingNavigation": false,
    "isFollowingVehicle":    false,
    "routeLineFollowing":    null,
};

/** Active navigation session (mode, follow camera, GPS line matching). */
export const navigationSessionSlice = defineEphemeralSlice<NavigationSession>( {
    "key":     "navigationSession",
    "default": () => NAVIGATION_SESSION_DEFAULT,
} );
